import { QueryClientProvider } from '@tanstack/react-query';
import { createContext, type ReactNode, useContext } from 'react';
import type { AppServices } from 'src/common/services';

const AppServicesContext = createContext<AppServices | null>(null);

interface AppServicesProviderProps {
  children: ReactNode;
  services: AppServices;
}

export function AppServicesProvider({ children, services }: AppServicesProviderProps) {
  return (
    <AppServicesContext.Provider value={services}>
      <QueryClientProvider client={services.queryClient}>{children}</QueryClientProvider>
    </AppServicesContext.Provider>
  );
}

export function useAppServices() {
  const services = useContext(AppServicesContext);

  if (!services) {
    throw new Error('useAppServices must be used within an AppServicesProvider');
  }

  return services;
}
